/**
 * Shared “product shell” hero styles for Prioritization (/prioritization) and Planning (/planning)
 * home dashboards — date ribbon + serif display title. Sub-pages (Plan of Record list, Strategy
 * Canvas, Clusters, etc.) use {@link PageHeader} instead.
 */

export function formatProductShellDateLabel(d: Date = new Date()): string {
  return d.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
}

/** Monochrome date ribbon — always Tailwind text-xs (12px) + mono + caps. */
export const PRODUCT_SHELL_DATE_CLASS =
  'font-mono text-xs tracking-[0.2em] uppercase mb-1 text-[var(--text-ter)] dark:text-[var(--text-ter)]';

/** Spectral display — semibold (600) for a warm, confident greeting; weight 300 read as thin/gothic at this size. */
export const PRODUCT_SHELL_TITLE_CLASS =
  'font-serif text-2xl font-semibold tracking-[0.02em] text-[var(--text-pri)] leading-snug';

export const PRODUCT_SHELL_SUBTITLE_CLASS =
  'text-sm font-light mt-0.5 text-[var(--text-ter)] dark:text-[var(--text-sec)]';

export function greetingForHour(d: Date = new Date()): 'Good morning' | 'Good afternoon' | 'Good evening' {
  const h = d.getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}
